import { useAuthStore } from '@/features/auth/store'

export function usePermission(perm: string): boolean {
  return useAuthStore((s) => s.hasPermission(perm))
}
